import { render, staticRenderFns } from "./LegalSearchComponent.vue?vue&type=template&id=0321e531&scoped=true"
import script from "./LegalSearchComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LegalSearchComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LegalSearchComponent.vue?vue&type=style&index=0&id=0321e531&lang=scss&scoped=true"
import style1 from "./LegalSearchComponent.vue?vue&type=style&index=1&id=0321e531&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321e531",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0321e531')) {
      api.createRecord('0321e531', component.options)
    } else {
      api.reload('0321e531', component.options)
    }
    module.hot.accept("./LegalSearchComponent.vue?vue&type=template&id=0321e531&scoped=true", function () {
      api.rerender('0321e531', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/search/LegalSearch/LegalSearchComponent.vue"
export default component.exports